export const faqs = [
  {
    question: "What services does CSL offer?",
    answer: "CSL offers a variety of services including ...",
  },
  {
    question: "How can I contact the support team?",
    answer: "You can contact the support team via ...",
  },
  {
    question: "What makes CSL unique in the industry?",
    answer: "CSL stands out due to ...",
  },
  {
    question: "How can I join the CSL team?",
    answer: "To join the CSL team, you can apply via ...",
  },
  {
    question: "How does CSL determine project costs?",
    answer: "Project costs are determined based on ...",
  },
  {
    question: "What if I'm not satisfied with the service provided?",
    answer: "If you're not satisfied, CSL offers ...",
  },
];
